import { getConnectionApplicationStatusBadgeColour } from '@/helpers/connectionApplications';
import { Badge, Card, Conditional, Field } from '@payaca/ambrosia';

import { Nullish } from '@payaca/utilities/types';
import { FC } from 'react';
interface DnoResponseCardProps {
  status: Nullish<string>;
  connectionApplicationStatus?: Nullish<string>;
  dnoComments?: Nullish<string>;
}

const DnoResponseCard: FC<DnoResponseCardProps> = (props) => {
  const { status, dnoComments, connectionApplicationStatus } = props;
  return (
    <>
      <Card>
        <Card.Body>
          <div className="flex gap-3 justify-between">
            <Card.Title>DNO Response</Card.Title>
            <Badge
              colour={getConnectionApplicationStatusBadgeColour(
                status || undefined
              )}
              variant="soft"
              className="capitalize"
            >
              {status}
              {connectionApplicationStatus &&
                ` (${connectionApplicationStatus})`}
            </Badge>
          </div>

          <Conditional condition={!!status}>
            <Field.Legacy className="mb-4 mt-4">
              <Field.Label>DNO Comments</Field.Label>
              <p className={!dnoComments ? 'text-gray-400' : ''}>
                {dnoComments ?? 'No comments'}
              </p>
            </Field.Legacy>
          </Conditional>
        </Card.Body>
      </Card>
      <hr className="mt-4" />
    </>
  );
};

export default DnoResponseCard;
